import styles from './VarItemCorrect.module.css';

const VarItemCorrect = ({
  item,
  i,
  withoutNum,
  answerFontSize,
  varNumFontSize,
  isQuestionImg,
}) => {
  return (
    <div
      className={styles.varInfo}
      style={{ minHeight: isQuestionImg ? 'none' : '20rem' }}>
      {!withoutNum && (
        <div
          className={styles.varNumber}
          style={{
            fontSize: `${varNumFontSize}rem`,
          }}>
          {i + 1}
        </div>
      )}
      <div
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          lineHeight: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '80rem' : '50rem',
          minWidth: '50rem',
        }}>
        {item?.comment}
      </div>
    </div>
  );
};

export default VarItemCorrect;
